import type { LucideIcon } from 'lucide-react'
import type { ButtonHTMLAttributes } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export interface FabProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: LucideIcon
  label: string
}

/**
 * Bouton d'action Mobile. Il occupait toute la largeur au-dessus de la
 * navigation et masquait la liste : il est désormais rond et n'affiche plus
 * son libellé, qui reste porté pour les lecteurs d'écran.
 */
export function Fab({ icon: Icon, label, className, type = 'button', ...props }: FabProps) {
  return (
    <button className={mergeClassNames('ds-fab', className)} type={type} {...props}>
      <Icon aria-hidden="true" />
      <span className="ds-fab__label">{label}</span>
    </button>
  )
}
